'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

/**
 * Restores scroll-to-top on client-side navigation.
 *
 *
 * It keys off the pathname only (not the query string), so index filtering and
 * pagination — which update search params with `{ scroll: false }` — are left
 * untouched, and it skips navigations that target an in-page `#anchor`.
 */
const ScrollToTop = () => {
  const pathname = usePathname();
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    if (window.location.hash) return;

    window.requestAnimationFrame(() => {
      const html = document.documentElement;
      const previous = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, 0);
      html.style.scrollBehavior = previous;
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
